<template>
  <div class="bgimage">
    <language @custom-event="handleChildEvent" v-show="false"/>
    <!-- <Nav></Nav> -->
    <div class="form-container">
      <img src="../assets/logo.png" alt="" srcset="" class="login_logo">
      <input type="text" class="usname" placeholder="用户名" v-model="logindata.usname" ref="usname">
      <input type="password" class="passwd" placeholder="密码" v-model="logindata.passwd" ref="passwd" @keyup.enter="login()">
      <button @click="login">
        <p v-if="lang == 'cn'">登录</p>
        <p v-if="lang == 'en'">Log in</p>
      </button>
    </div>
  </div>
</template>

<script>
import {
  loginpost,
 } from '@/utils/home/home.js'
import Nav from './nav.vue';
import language from './language.vue';

    export default {

        components: {
            Nav,
            language,
        },

        data() {
            return {
              lang:'cn',
              logindata:{
                // usname:'13106008254',
                usname:'',
                // passwd:'123456',
                passwd:''
              }
            }
        },
        methods:{
          generatemessage(msg,time){  //生成提示框
            const messageBox = document.createElement('div');
            messageBox.className = 'promptbox'
            messageBox.textContent = msg;
            messageBox.style.position = 'fixed';
            messageBox.style.transition = 'all .3s';
            messageBox.style.opacity = '0';
            messageBox.style.top = '50%';
            messageBox.style.left = '50%';
            messageBox.style.transform = 'translate(-50%, -50%)';
            messageBox.style.padding = '20px 40px';
            messageBox.style.background = '#000';
            messageBox.style.color = '#fff';
            messageBox.style.borderRadius = '5px';
            messageBox.style.fontFamily = 'Arial, sans-serif';
            messageBox.style.fontSize = '18px';
            messageBox.style.zIndex = '9999';
            document.body.appendChild(messageBox);
            setTimeout(() => {
                messageBox.style.opacity = '1';
            }, 1);
            setTimeout(() => {
                messageBox.style.opacity = '0';
            }, 1700);
            setTimeout(function () {
                document.body.removeChild(messageBox);
            }, time);
          },
          login(){ // 获取介绍内容
            if(this.logindata.usname == '' || this.logindata.passwd == ''){
              this.generatemessage('用户名或密码为空',2000)
              return
            }else{
              loginpost(this.logindata).then(res=>{
                if(res.status ==200){
                  console.log(res);
                  if(res.data.code == 0){ //成功
                    sessionStorage.setItem('isLoggedIn',true); // 存入一个值
                    sessionStorage.setItem('limits',res.data.data.models); // 存入一个值
                    this.$router.push('/fpq'); // 跳转到目标页面
                    console.log(res.data.msg);
                    if(this.lang == 'cn'){
                      this.generatemessage('登录成功',2000)
                    }else{
                      this.generatemessage('Login succeeded',2000)
                    }
                  }
                  if(res.data.code == -1){ //失败
                    sessionStorage.setItem('isLoggedIn',false); // 存入一个值
                    sessionStorage.setItem('limits',undefined); // 存入一个值
                    // alert(res.data.msg);
                    if(this.lang == 'cn'){
                      this.generatemessage('登录失败',2000)
                    }else{
                      this.generatemessage('Login failed',2000)
                    }
                  }
                  console.log('登陆状态',sessionStorage.getItem('isLoggedIn'));// => 返回testKey对应的值
                }
              }).catch(err=>{
                console.log(err);
                if(this.lang == 'cn'){
                  this.generatemessage('错误',2000)
                }else{
                  this.generatemessage('error',2000)
                }
              })

            }
          },

          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
          },
        },

        mounted(){
          sessionStorage.setItem('isLoggedIn',false); // 存入一个值
          this.lang = sessionStorage.getItem('language');
          if(this.lang == 'cn'){
            this.$refs.usname.placeholder = '用户名'
            this.$refs.passwd.placeholder = '密码'
          }else{
            this.$refs.usname.placeholder = 'username'
            this.$refs.passwd.placeholder = 'password'
          }
          // this.login()
        },
    }
</script>

<style scoped>
.login_logo{
  width: 60%;
  margin-top: 50px;
  margin-bottom: 30px;
}
.bgimage{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-image: url(../assets/images/loader-bg.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* background-image: none; */
}
.form-container{
  width: 500px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(230, 230, 230, 0.3);
  backdrop-filter: blur(5px);
  border-radius: 5px;
}
.form-container input{
  width: 300px;
  height: 40px;
  font-size:16px;
  margin-top: 30px;
  box-shadow: none;
  outline: none;
  padding-left: 20px;
  /* background: #F8F8FF; */
  /* color: #F8A000; */
  border-top:none !important;
  border-left:none !important;
  border-right:none !important;
  border-bottom:none !important;
  border-radius: 5px !important;
}
.form-container button{
  font-size:16px;
  margin-top: 30px;
  width: 120px;
  height: 40px;
  border:none;
  border-radius: 5px;
  cursor: pointer;
  transition: all .3s;
}
.form-container button:hover{
  background-color: #232323;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue